import { Component, EventEmitter, Input, Output, QueryList, ContentChildren} from '@angular/core';
import { ModalHeaderProps, modalHeaderStyles } from '@kite_aerolab/shared/components';

import { IconComponent } from '../icon/icon.component'

@Component({
  selector: 'kite-modal-header',
  templateUrl: './modal-header.component.html',
})
export class ModalHeaderComponent {
  @Input() css: ModalHeaderProps['css'];
  @Input() title: ModalHeaderProps['title'];
  @Input() id = '';

  @ContentChildren(IconComponent) list: QueryList<IconComponent>;

  @Output() toggle = new EventEmitter<boolean>();

  public get modalHeader(): string[] {
    return [modalHeaderStyles({ css: this.css }).className];
  }

  toggleOpen(value: boolean) {
    this.toggle.emit(value);
  }
}
